import React, {Component} from 'react';
import {Col, Row} from 'react-bootstrap';

class GroupOptionsPanel extends Component {
    
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        
    }

    componentWillUnmount() {
        
    }
    
    render() {
        return (
            <Row className="d-flex align-items-center" style={{padding: 5, backgroundColor: '#F1F2F3', zIndex :1010}}>
                <Col xs={6} style={{'display':'inline'}}>
                   
                </Col>
                {this.props._rhs_options_panel(6,true)}          
            </Row>
        );
    }
}

export default GroupOptionsPanel;